import React from 'react';

const AutomotiveFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="4.9375" cy="13.5625" r="2.0625" strokeWidth="1.5" />
    <circle cx="15.0625" cy="13.5625" r="2.0625" strokeWidth="1.5" />
    <path
      d="M17.3125 13V13C18.2445 13 19 12.2445 19 11.3125V10.9414C19 9.88528 18.1788 9.01118 17.1248 8.9453L2.06238 8.0039C1.48668 7.96792 1 8.42513 1 9.00195V11C1 12.1046 1.89543 13 3 13H3.25"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.25 7.375L4.90627 4.8906C5.2772 4.3342 5.90166 4 6.57037 4H10.78C11.3567 4 11.9053 4.24896 12.2851 4.68299L15.625 8.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.1875 13H12.8125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default AutomotiveFilterIcon;
